
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Quelle est son efficacité?`}</em></p>
    <p><a parentName="p" {...{
        "href": "https://www.nejm.org/doi/full/10.1056/NEJMoa2034577"
      }}>{`95% de protection contre une infection symptomatique`}</a>{`.
Particularité: des personnes à partir de 16 ans ont été intégrées dans les
premiers essais et le vaccin a pu être administré à partir de cet âge dès le
début.`}</p>
    <p>{`Selon une étude de Pfizer et du réseau de santé américain Kaiser Permanente,
parue le 5 octobre 2021 dans la revue "The Lancet" et menée avec les données
médicales de 3,4 millions de personnes en Caroline du Sud (USA),
`}<a parentName="p" {...{
        "href": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(21)02183-8/fulltext"
      }}>{`l'efficacité du vaccin contre les risques d'infection diminue avec le temps`}</a>{`.
Elle passe de 88% dans le mois suivant la deuxième dose à 47% après cinq mois
(tous types d'infections).`}</p>
    <p>{`Pour les infections qui ont été séquencées, la protection contre le variant
Delta passe de 93% durant le premier mois à 53% après quatre mois. Et de 97% à
67% (après quatre à cinq mois) pour les autres variants. L'efficacité contre les
hospitalisations est plus élevée. En cas d'infection avec le variant Delta, elle
reste de 93% durant au moins six mois.`}</p>
    <p>{`Selon les auteurs de cette étude, la réduction de l'efficacité au fil du temps
est probablement due à la diminution de l'immunité plutôt qu'au fait que le
variant Delta échappe à la protection vaccinale.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;